/**
 * 路线设置的展示逻辑（14.39b）：`GlobalState.netRoute` 切片 + 切换中标记 → 行视图。
 * 纯函数，供路线设置页与登录页内联开关行共用（useRouteSwitch 包状态）。
 *
 * 两处口径（数据链 14.39a 的决策⑤延续）：
 * - **不乐观写**：切片未变之前开关位置不动——切错路线等于整个 App 连不上，
 *   不能先把开关拨过去再回滚。期间整行禁用、副标题显「切换中…」给反馈。
 * - 切片 `null`（Worker 刚拉起、kv 还没回包）按**国内路线**占位显示，且不许切：
 *   此刻不知道现值，点一下可能切成同值（幂等无害）也可能切错方向。
 */

import { apiBaseDisplay, DEFAULT_API_BASE_URL } from '~/util/apiBase';
import type { NetRouteSlice } from '~/store/netRouteState';

/** 旧版 route_settings_screen / login_page 同文案 */
export const ROUTE_ROW_LABEL = '海外路线';
export const ROUTE_SECTION_LABEL = '访问路线';
export const ROUTE_SWITCHING_TEXT = '切换中…';
export const ROUTE_ERROR_FALLBACK = '切换失败，请稍后重试';

export interface RouteRowView {
  /** 开关位置（= 切片现值，切换中也不动） */
  readonly overseas: boolean;
  /** 当前生效的 API 域名（同源路线=空串，展示请用 sub） */
  readonly baseUrl: string;
  /**
   * 副标题：切换中显进度，否则显生效域名（旧版副标题=海外域名常量，这里显实际
   * 生效值更准）。同源路线（baseUrl 空串，21ah-4 起的默认）显当前站点 origin。
   */
  readonly sub: string;
  /** 切片已回包且不在切换中 */
  readonly canToggle: boolean;
}

export function routeRowView(
  slice: NetRouteSlice,
  busy: boolean,
  /** 当前站点 origin（同源路线的副标题显它）；调用方传 location.origin */
  origin = '',
): RouteRowView {
  const overseas = slice?.overseas ?? false;
  const baseUrl = slice?.baseUrl ?? DEFAULT_API_BASE_URL;
  return {
    overseas,
    baseUrl,
    sub: busy ? ROUTE_SWITCHING_TEXT : apiBaseDisplay(baseUrl, origin),
    canToggle: slice !== null && !busy,
  };
}
